import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown, MapPin } from 'lucide-react';
import { images } from '../data/site';
const ease = [0.22, 1, 0.36, 1] as const;
export function Hero() {
  return <section id="home" className="relative flex min-h-[100svh] w-full items-end overflow-hidden bg-ocean-deep" data-id="element-146" data-mp="9k0g9cbeknrr">
      <motion.img src={images.hero} alt="Rainforest hillside dropping down to a turquoise bay on the coast of Taveuni, Fiji" className="absolute inset-0 h-full w-full object-cover object-[68%_50%] sm:object-center" initial={{
      scale: 1.12,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} transition={{
      duration: 1.8,
      ease
    }} data-id="element-147" data-mp="4na06ozlls6c" />
      <div className="absolute inset-0 bg-gradient-to-t from-ocean-deep/92 via-ocean-deep/45 to-ocean-deep/40" data-id="element-148" data-mp="nb6n5th0hnoo" />
      <div className="absolute inset-0 bg-gradient-to-r from-ocean-deep/55 via-transparent to-transparent" data-id="element-149" data-mp="3d33h34xud5nx" />

      <div className="relative mx-auto w-full max-w-[1400px] px-5 pb-16 pt-32 sm:px-8 sm:pb-20 lg:px-12 lg:pb-24" data-id="element-150" data-mp="3814a7l2w7qm8">
        <motion.div className="flex items-center gap-2.5 text-[11px] font-medium uppercase tracking-wider-xl text-ivory/80" initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4,
        duration: 0.8,
        ease
      }} data-id="element-151" data-mp="3j6obvk13emq3">
          <MapPin className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-152" data-mp="3e7l8e40rgok8" />
          Taveuni, Fiji
        </motion.div>

        <motion.h1 className="mt-6 max-w-4xl font-serif text-[clamp(2.75rem,9vw,7rem)] font-light leading-[0.95] tracking-[0.01em] text-ivory" initial={{
        opacity: 0,
        y: 28
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.55,
        duration: 1,
        ease
      }} data-id="element-153" data-mp="30g6kpjvwrz6u">
          Your Home
          <span className="block italic text-gold-soft" data-id="element-154" data-mp="2hinawe1mmcjd">in Taveuni</span>
        </motion.h1>

        <motion.div className="mt-8 max-w-xl border-l border-gold/50 pl-5" initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.75,
        duration: 0.9,
        ease
      }} data-id="element-155" data-mp="2lkilk95g629t">
          <p className="font-serif text-2xl italic text-ivory/95 sm:text-[28px]" data-id="element-156" data-mp="naji3pzjuhg2">
            Stay local. Wake up in paradise.
          </p>
          <p className="mt-3 text-[15px] leading-relaxed text-ivory/75" data-id="element-157" data-mp="i9vuleaj4iql">
            A peaceful tropical homestay in Taveuni, Fiji, with homemade
            breakfast included.
          </p>
        </motion.div>

        <motion.div className="mt-10 flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.95,
        duration: 0.9,
        ease
      }} data-id="element-158" data-mp="1622idp26vhee">
          <a href="#book" className="rounded-full bg-ivory px-8 py-4 text-center text-[11px] font-semibold uppercase tracking-[0.2em] text-forest-deep transition-all duration-300 ease-calm hover:-translate-y-0.5 hover:bg-gold hover:shadow-lift" data-id="element-159" data-mp="x0uwy7krub1q">
            Book your stay
          </a>
          <a href="#taveuni" className="rounded-full border border-ivory/45 px-8 py-4 text-center text-[11px] font-semibold uppercase tracking-[0.2em] text-ivory transition-all duration-300 ease-calm hover:-translate-y-0.5 hover:border-ivory hover:bg-ivory/10" data-id="element-160" data-mp="1x7hvvdunc30v">
            Explore Taveuni
          </a>
        </motion.div>

        <motion.a href="#intro" aria-label="Scroll to content" className="mt-14 hidden items-center gap-3 text-[10px] uppercase tracking-wider-xl text-ivory/55 transition-colors hover:text-ivory lg:inline-flex" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1.3,
        duration: 1
      }} data-id="element-161" data-mp="2fz0xbg90v90s">
          <ArrowDown className="h-4 w-4 animate-bounce" aria-hidden="true" data-id="element-162" data-mp="un98lk4twddk" />
          Scroll
        </motion.a>
      </div>
    </section>;
}